// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Core from "@material-ui/core";
import * as App_Icon$DvmAdminFrontendFr from "../../../../common/components/icons/App_Icon.bs.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../../intl/Intl_Utils.bs.js";
import * as Theme_Colors$DvmAdminFrontendFr from "../../../../theme/Theme_Colors.bs.js";
import * as App_LabeledText$DvmAdminFrontendFr from "../../../../common/components/App_LabeledText.bs.js";
import * as Order_Detail_Styles$DvmAdminFrontendFr from "../Order_Detail_Styles.bs.js";
import * as Messages_Flash_Search$DvmAdminFrontendFr from "../../../../intl/messages/flash/Messages_Flash_Search.bs.js";
import * as Messages_Orders_Detail$DvmAdminFrontendFr from "../../../../intl/messages/orders/Messages_Orders_Detail.bs.js";
import * as Order_Detail_Bonus_Box_Shared$DvmAdminFrontendFr from "./Order_Detail_Bonus_Box_Shared.bs.js";

function Order_Detail_Bonus_Box_Fleet(Props) {
  var bonus = Props.bonus;
  var archived = Props.archived;
  var filteredRequest = Props.filteredRequest;
  var intl = ReactIntl.useIntl();
  return React.createElement(Core.Grid, {
              children: null,
              container: true,
              item: true,
              wrap: "nowrap"
            }, React.createElement(Order_Detail_Bonus_Box_Shared$DvmAdminFrontendFr.Status.make, {
                  bonus: bonus
                }), React.createElement(Core.Grid, {
                  children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                        label: Messages_Flash_Search$DvmAdminFrontendFr.bonusType,
                        children: Belt_Option.getWithDefault(bonus.actionType, "")
                      }),
                  className: Order_Detail_Styles$DvmAdminFrontendFr.bonusesItemNew,
                  container: true,
                  item: true
                }), React.createElement(Core.Grid, {
                  children: React.createElement(Order_Detail_Bonus_Box_Shared$DvmAdminFrontendFr.ClickableFlash.make, {
                        bonus: bonus,
                        filteredRequest: filteredRequest,
                        kind: "fleet"
                      }),
                  className: Order_Detail_Styles$DvmAdminFrontendFr.bonusesItemNew,
                  container: true,
                  item: true
                }), React.createElement(Core.Grid, {
                  children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                        label: Messages_Flash_Search$DvmAdminFrontendFr.bonusLabel,
                        children: Belt_Option.getWithDefault(bonus.actionLabel, "-")
                      }),
                  className: Order_Detail_Styles$DvmAdminFrontendFr.bonusesItemDoubleWide,
                  container: true,
                  item: true
                }), React.createElement(Core.Grid, {
                  children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                        label: Messages_Orders_Detail$DvmAdminFrontendFr.preinvoiceDate,
                        children: Belt_Option.mapWithDefault(bonus.resultPreinvoiceDate, "-", (function (param) {
                                return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                              }))
                      }),
                  className: Order_Detail_Styles$DvmAdminFrontendFr.bonusesItemNew,
                  container: true,
                  item: true
                }), React.createElement(Core.Grid, {
                  children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                        label: Messages_Orders_Detail$DvmAdminFrontendFr.preinvoiceNumber,
                        children: Belt_Option.mapWithDefault(bonus.resultPreinvoiceNumber, "-", (function (x) {
                                if (x.length === 0) {
                                  return "-";
                                } else {
                                  return x;
                                }
                              }))
                      }),
                  className: Order_Detail_Styles$DvmAdminFrontendFr.bonusesItemNew,
                  container: true,
                  item: true
                }), React.createElement(Core.Grid, {
                  children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                        label: Messages_Orders_Detail$DvmAdminFrontendFr.bapInvoiceDate,
                        children: Belt_Option.mapWithDefault(bonus.resultInvoiceDate, "-", (function (param) {
                                return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                              }))
                      }),
                  className: Order_Detail_Styles$DvmAdminFrontendFr.bonusesItemDoubleWide,
                  container: true,
                  item: true
                }), React.createElement(Core.Grid, {
                  children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                        label: Messages_Orders_Detail$DvmAdminFrontendFr.actionAmount,
                        children: React.createElement(Core.Grid, {
                              alignItems: "flex-start",
                              children: null,
                              container: true,
                              item: true,
                              wrap: "nowrap"
                            }, React.createElement(Core.Grid, {
                                  children: Order_Detail_Bonus_Box_Shared$DvmAdminFrontendFr.getAmountText(bonus, archived, intl),
                                  item: true
                                }), Belt_Option.mapWithDefault(bonus.resultActionStatus, false, (function (x) {
                                    if (x === /* PREINVOICED */5 || x === /* NOBONUS */3) {
                                      return true;
                                    } else {
                                      return x === /* PAID */4;
                                    }
                                  })) ? React.createElement(Core.Grid, {
                                    children: React.createElement(App_Icon$DvmAdminFrontendFr.make, {
                                          size: /* Large */3,
                                          type_: /* Tick */1,
                                          color: Theme_Colors$DvmAdminFrontendFr.accentGreen
                                        }),
                                    item: true
                                  }) : null)
                      }),
                  className: Order_Detail_Styles$DvmAdminFrontendFr.bonusesItemNew,
                  container: true,
                  item: true
                }));
}

var Styles;

var Shared;

var make = Order_Detail_Bonus_Box_Fleet;

export {
  Styles ,
  Shared ,
  make ,
}
/* react Not a pure module */
